import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TabContainer } from '@components';
import { CdnDashboardTab, DashboardEndpoint, Translation } from '@enums';
import { getCdnDashboardTabs, validateValueEqual } from '@utils';

import { DashboardFilter } from './dashboardFilter';
import { AttackLog } from './subPages/attackLog';
import { ErrorLog } from './subPages/errorLog';
import { LogPage } from './subPages/logPage';
import { TrafficPage } from './subPages/trafficPage';
import { WafLog } from './subPages/wafLog';

export const CdnDashboard = () => {
  const [activeTab, setActiveTab] = useState<CdnDashboardTab>(CdnDashboardTab.TRAFFIC);
  const { t } = useTranslation(Translation.Configuration, { keyPrefix: 'tabs.dashboard' });

  const contentConfig = useCallback(() => {
    return {
      [CdnDashboardTab.ATTACK_LOG]: <AttackLog />,
      [CdnDashboardTab.ERROR_LOG]: <ErrorLog />,
      [CdnDashboardTab.LOG]: <LogPage />,
      [CdnDashboardTab.TRAFFIC]: <TrafficPage />,
      [CdnDashboardTab.WAF_LOG]: <WafLog />,
    };
  }, []);

  const DashboardTabs = useMemo(() => getCdnDashboardTabs(), [t]);

  return (
    <div className="w-full flex flex-col flex-1 gap-6 sm:gap-8">
      <TabContainer<CdnDashboardTab>
        tabs={DashboardTabs}
        onTabChange={setActiveTab}
        contentConfig={contentConfig()}
        contentClassName="gap-6 sm:gap-8"
        adornment={
          validateValueEqual(activeTab, CdnDashboardTab.TRAFFIC) ? (
            <DashboardFilter currentTab={activeTab} targetFrom={DashboardEndpoint.TOTAL_TRAFFIC} />
          ) : null
        }
      />
    </div>
  );
};
